export enum AllOrInternationalFilter {
  ALL = 'All',
  INTERNATIONAL = 'International'
}
